/**
 * Notification Utilities
 *
 * Provides functions for playing a notification sound using HTML5 Audio
 * and flashing the browser tab title when a notification arrives.
 */

let titleInterval = null;
let originalTitle = document.title;
let isFlashing = false;

// Preload the audio file to ensure it plays immediately when called.
// You must place a valid audio file named 'notification.mp3' inside the /public folder
const notificationAudio = new Audio('/notification.mp3');

/**
 * Plays the MP3 notification sound using HTML5 Audio.
 */
export const playNotificationSound = () => {
    try {
        // Reset playback to start, just in case it's currently playing
        notificationAudio.currentTime = 0;
        const playPromise = notificationAudio.play();

        if (playPromise !== undefined) {
            playPromise.catch((error) => {
                // Browsers often block autoplay until the user interacts with the document
                console.warn('Playback prevented by browser autoplay policy, or /notification.mp3 is missing. Error:', error);
            });
        }
    } catch (e) {
        console.warn('Could not play notification sound:', e);
    }
};

/**
 * Starts flashing the document title.
 * @param {string} flashText - The text to alternate with the original title.
 */
export const startTabAlert = (flashText) => {
    if (isFlashing) return;
    isFlashing = true;
    
    // Store original title if it hasn't been modified by us yet
    if (document.title !== flashText) {
        originalTitle = document.title;
    }

    let showFlashAlert = true;
    titleInterval = setInterval(() => {
        document.title = showFlashAlert ? flashText : originalTitle;
        showFlashAlert = !showFlashAlert;
    }, 1000);
};

/**
 * Stops the document title from flashing and restores the original title.
 */
export const stopTabAlert = () => {
    if (!isFlashing) return;
    
    clearInterval(titleInterval);
    document.title = originalTitle;
    isFlashing = false;
};
